import api from './api';

async function fetchDocuments(category, params) {
  return api.get(`/documents/${category}`, params)
}

async function addDocument(formData) {
  return api.post('/documents', formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

async function updateDocument(documentId, payload) {
  return api.put(`/documents/document/${documentId}`, payload);
}

async function deleteDocument(documentId) {
  return api.delete(`/documents/document/${documentId}`);
}

export { fetchDocuments, addDocument, updateDocument, deleteDocument };